import $ from 'jquery'

export default {

  enable () {
    
    let navbar = $('.navbar')
    let menu = $('#off-canvas-menu')

    $(menu).on('opened.zf.offcanvas', () => {
      $(navbar).addClass('is-open-left')
    })
  
    $(menu).on('closed.zf.offcanvas', () => {
      $(navbar).removeClass('is-open-left')
    })
    
    let itemsWithSubMenu = $(menu).find('.menu-item').has('ul')

    $(itemsWithSubMenu).each((index, item) => {
      let arrow = $('<i class="show-submenu icon-chevron-thin-down"></i>')
      $(item).append(arrow)
      $(arrow).click(() => {
        if($(item).hasClass('open')){
          $(item).removeClass('open')
          $(arrow).removeClass('icon-chevron-thin-up')
          $(arrow).addClass('icon-chevron-thin-down')   
        } else {
          $(item).addClass('open')
          $(arrow).removeClass('icon-chevron-thin-down')
          $(arrow).addClass('icon-chevron-thin-up')
        }
      }) 
    })
       
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/navbar.js